import React, { useState } from "react";
import { Form, Input, Button, Switch, Select, message } from "antd";

const { Option } = Select;

const ImportSettings = () => {
  const [settings, setSettings] = useState({
    autoImportEnabled: false,
    importFrequency: "weekly", // Može biti: daily, weekly, monthly
    xmlUrls: [],
    checkStockFrequency: "weekly",
  });

  // Dodavanje XML linka u listu
  const handleAddXmlUrl = () => {
    setSettings({ ...settings, xmlUrls: [...settings.xmlUrls, ""] });
  };

  // Promena vrednosti XML linka
  const handleXmlUrlChange = (index, value) => {
    const updatedUrls = [...settings.xmlUrls];
    updatedUrls[index] = value;
    setSettings({ ...settings, xmlUrls: updatedUrls });
  };

  // Promena podešavanja
  const handleChange = (key, value) => {
    setSettings({ ...settings, [key]: value });
  };

  // Snimanje podešavanja
  const handleSaveSettings = () => {
    console.log("📥 Snimanje podešavanja u bazu:", settings);
    message.success("Podešavanja uspešno sačuvana!");
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
      <h2>Podešavanja uvoza</h2>
      <Form layout="vertical" onFinish={handleSaveSettings}>
        {/* Automatski uvoz podataka */}
        <Form.Item label="Automatski uvoz podataka">
          <Switch
            checked={settings.autoImportEnabled}
            onChange={(checked) => handleChange("autoImportEnabled", checked)}
          />
        </Form.Item>

        {/* Frekvencija automatskog uvoza */}
        {settings.autoImportEnabled && (
          <Form.Item label="Učestalost automatskog uvoza">
            <Select
              value={settings.importFrequency}
              onChange={(value) => handleChange("importFrequency", value)}
            >
              <Option value="daily">Svakodnevno</Option>
              <Option value="weekly">Nedeljno</Option>
              <Option value="monthly">Mesečno</Option>
            </Select>
          </Form.Item>
        )}

        {/* XML URL linkovi za dobavljače */}
        <Form.Item label="XML URL-ovi za automatski uvoz">
          {settings.xmlUrls.map((url, index) => (
            <Input
              key={index}
              placeholder="Unesite URL XML fajla"
              value={url}
              onChange={(e) => handleXmlUrlChange(index, e.target.value)}
              style={{ marginBottom: "10px" }}
            />
          ))}
          <Button type="dashed" onClick={handleAddXmlUrl}>
            Dodaj novi XML link
          </Button>
        </Form.Item>

        {/* Provera stanja na lageru */}
        <Form.Item label="Provera dostupnosti proizvoda">
          <Select
            value={settings.checkStockFrequency}
            onChange={(value) => handleChange("checkStockFrequency", value)}
          >
            <Option value="daily">Svakodnevno</Option>
            <Option value="weekly">Nedeljno</Option>
            <Option value="monthly">Mesečno</Option>
          </Select>
        </Form.Item>

        {/* Dugme za čuvanje podešavanja */}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Sačuvaj podešavanja
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ImportSettings;
